import React from "react";
import { Mail, MapPin } from "lucide-react";

const WealthFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-brandNavy text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">The W.E.A.L.T.H. Method</h3>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              Building sustainable digital wealth for Nigerian entrepreneurs
              through proven systems and strategies.
            </p>
            <div className="space-y-2 text-sm text-gray-400">
              <div className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-1 flex-shrink-0" />
                <span>Lagos, Nigeria</span>
              </div>
              <div className="flex items-start gap-2">
                <Mail className="w-4 h-4 mt-1 flex-shrink-0" />
                <a
                  href="mailto:support@wealthmethod.ng"
                  className="hover:text-brandRed transition-colors"
                >
                  support@wealthmethod.ng
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-3 text-sm text-gray-400">
              <li>
                <a
                  href="#about"
                  className="hover:text-brandRed transition-colors"
                >
                  About the Book
                </a>
              </li>
              <li>
                <a
                  href="#author"
                  className="hover:text-brandRed transition-colors"
                >
                  About the Author
                </a>
              </li>
              <li>
                <a
                  href="#testimonials"
                  className="hover:text-brandRed transition-colors"
                >
                  Success Stories
                </a>
              </li>
              <li>
                <a
                  href="#faq"
                  className="hover:text-brandRed transition-colors"
                >
                  FAQ
                </a>
              </li>
              <li>
                <a
                  href="#contact"
                  className="hover:text-brandRed transition-colors"
                >
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-bold text-lg mb-4">Resources</h4>
            <ul className="space-y-3 text-sm text-gray-400">
              <li>
                <a
                  href="#sample"
                  className="hover:text-brandRed transition-colors"
                >
                  Free Sample Chapter
                </a>
              </li>
              <li>
                <a
                  href="#templates"
                  className="hover:text-brandRed transition-colors"
                >
                  Free Templates
                </a>
              </li>
              <li>
                <a
                  href="#community"
                  className="hover:text-brandRed transition-colors"
                >
                  Join Community
                </a>
              </li>
              <li>
                <a
                  href="#blog"
                  className="hover:text-brandRed transition-colors"
                >
                  Blog
                </a>
              </li>
              <li>
                <a
                  href="#podcast"
                  className="hover:text-brandRed transition-colors"
                >
                  Podcast
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-bold text-lg mb-4">Legal</h4>
            <ul className="space-y-3 text-sm text-gray-400">
              <li>
                <a
                  href="#privacy"
                  className="hover:text-brandRed transition-colors"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  href="#terms"
                  className="hover:text-brandRed transition-colors"
                >
                  Terms of Service
                </a>
              </li>
              <li>
                <a
                  href="#refund"
                  className="hover:text-brandRed transition-colors"
                >
                  Refund Policy
                </a>
              </li>
              <li>
                <a
                  href="#shipping"
                  className="hover:text-brandRed transition-colors"
                >
                  Shipping Policy
                </a>
              </li>
              <li>
                <a
                  href="#disclaimer"
                  className="hover:text-brandRed transition-colors"
                >
                  Disclaimer
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-brandLightNavy my-8"></div>

        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
          <div className="text-center md:text-left">
            <p>© {currentYear} The W.E.A.L.T.H. Method. All rights reserved.</p>
          </div>

          {/* Social Links - Optional */}
          <div className="flex items-center gap-6">
            <a
              href="#facebook"
              className="hover:text-brandRed transition-colors"
            >
              Facebook
            </a>
            <a
              href="#twitter"
              className="hover:text-brandRed transition-colors"
            >
              Twitter
            </a>
            <a
              href="#instagram"
              className="hover:text-brandRed transition-colors"
            >
              Instagram
            </a>
            <a
              href="#linkedin"
              className="hover:text-brandRed transition-colors"
            >
              LinkedIn
            </a>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="mt-8 pt-8 border-t border-brandLightNavy">
          <p className="text-xs text-gray-500 leading-relaxed text-center md:text-left">
            <strong className="text-gray-400">Disclaimer:</strong> The
            information provided in this book is for educational purposes only.
            Results may vary based on individual effort, market conditions, and
            implementation. Past success stories are not guarantees of future
            results. We do not guarantee specific income outcomes. Success
            requires dedication, hard work, and consistent application of the
            principles taught.
          </p>
        </div>
      </div>

      {/* Very Bottom Strip */}
      <div className="bg-black bg-opacity-30 py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-xs text-gray-500 text-center">
            This site is not a part of the Facebook website or Facebook Inc.
            Additionally, this site is NOT endorsed by Facebook in any way.
            FACEBOOK is a trademark of FACEBOOK, Inc.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default WealthFooter;
